<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Advisory board </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"
            alt="GHRSCF" />
    </div>
</section>
<section class="section section-sm about-us section-banner-bg-1">
    <div class="container">
        <div class="widget_title inner-title">
            <h4>ADVISORY BOARD</h4>
        </div>

        <div class="row row-cols-lg-4 justify-content-center align-items-center text-justify">

            <div class="col">
                <div class="team-pattern-2">
                    <img loading="lazy" decoding="async"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/team/sunil-raisoni.webp"
                        class="img-fluid w-100" alt="Shri. Sunil Raisoni | Raisoni Education">
                    <div class="team-details text-center">
                        <h5 class="fw-bold">Shri. Sunil Raisoni</h5>
                        <!-- <p class="mb-0">Chairman</p> -->
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="team-pattern-2">
                    <img loading="lazy" decoding="async"
                        src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/team/shobha-raisoni.webp"
                        class="img-fluid w-100" alt="Smt. Shobha Raisoni | Raisoni Education">
                    <div class="team-details text-center">
                        <h5 class="fw-bold">Smt. Shobha Raisoni</h5>
                        <!-- <p class="mb-0">Patron</p> -->
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
